// import external dependencies
import 'jquery';

// Import everything from autoload
import "./autoload/_bootstrap.js"

/*
@fortawesome:registry=https://npm.fontawesome.com/
//npm.fontawesome.com/:_authToken=B74D6DC9-9C22-4628-B46E-EC845B78658C

in a file called .npmrc in root of this theme

yarn add @fortawesome/fontawesome-svg-core
yarn add @fortawesome/free-brands-svg-icons
yarn add @fortawesome/pro-regular-svg-icons
yarn add @fortawesome/pro-solid-svg-icons
*/

// import then needed Font Awesome functionality
import { /*config,*/ library, dom } from '@fortawesome/fontawesome-svg-core';
// import the Social icons
import { faEdit, faEye } from '@fortawesome/pro-solid-svg-icons';
import { faStickyNote, faCheck, faTimes } from '@fortawesome/pro-regular-svg-icons';

//import { faFacebookF, faTwitter, faYoutube, faGooglePlusG, faPinterest, faLinkedin, faInstagram, faSnapchatGhost } from "@fortawesome/free-brands-svg-icons";

import { faQuestionCircle, faTrashAlt } from "@fortawesome/pro-regular-svg-icons";
import { faPlusCircle } from "@fortawesome/pro-solid-svg-icons";
// add pseudo elements
//config.searchPseudoElements = true;

// add the imported icons to the library
library.add(faQuestionCircle, faTrashAlt, faPlusCircle, faEdit, faEye, faStickyNote, faCheck, faTimes);
// tell FontAwesome to watch the DOM and add the SVGs when it detects icon markup
dom.watch();


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import login from './routes/login';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  // Login page
  login,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());








// WEBPACK FOOTER //
// ./scripts/main.js